if (!customElements.get('product-media')) {
  /**
   * Uses Swiper package to create a carousel for product media
   * More info: https://swiperjs.com/
   */
  class ProductMedia extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        slider: '[data-slider]',
        thumbs: '[data-thumbs]',
        mediaItem: '[data-media-id]',
      };
      this.selectedMediaIndex =
        Number(
          this.querySelector(this.selectors.slider).querySelector('[data-selected]')?.dataset.index
        ) || 0;
      this.settings = {
        elements: {
          slider: this.querySelector(this.selectors.slider),
          thumbs: this.querySelector(this.selectors.thumbs),
        },
        instances: {
          slider: null,
          thumbs: null,
        },
        options: {
          slider: {
            initialSlide: this.selectedMediaIndex,
            spaceBetween: 20,
            watchOverflow: true,
            navigation: {
              prevEl: this.querySelector('.swiper-arrow--prev'),
              nextEl: this.querySelector('.swiper-arrow--next'),
            },
          },
          thumbs: {
            breakpoints: {
              990: {
                direction: 'vertical',
                spaceBetween: 10,
              },
            },
            freeMode: true,
            slideToClickedSlide: true,
            slidesPerView: 'auto',
            initialSlide: this.selectedMediaIndex,
            spaceBetween: 7.5,
            observer: true,
            observeParents: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            centeredSlidesBounds: true,
          },
        },
      };

      this.setSwiperMaxHeightRef = this.setSwiperMaxHeight.bind(this);
    }

    setSwiperMaxHeight() {
      const siblingEl = this.querySelector(this.selectors.slider + ' .swiper-wrapper');

      if (!siblingEl) return;

      this.style.setProperty('--thumb-max-height', siblingEl.getBoundingClientRect().height + 'px');
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.setSwiperMaxHeightRef);
      window.removeEventListener('resize', this.setSwiperMaxHeightRef);
    }

    connectedCallback() {
      this.init();

      window.addEventListener('load', this.setSwiperMaxHeightRef);
      window.addEventListener('resize', this.setSwiperMaxHeightRef);
    }

    init() {
      if (!this.settings.elements.slider || !this.settings.elements.thumbs) return;

      this.settings.instances.thumbs = new Swiper(
        this.settings.elements.thumbs,
        this.settings.options.thumbs
      );
      this.settings.options.slider.thumbs = {
        swiper: this.settings.instances.thumbs,
        autoScrollOffset: 1,
      };

      this.settings.instances.slider = new Swiper(
        this.settings.elements.slider,
        this.settings.options.slider
      );

      this.settings.instances.thumbs.on('click', (swiper) => {
        const idx = swiper.clickedIndex;
        if (typeof idx === 'number') this.settings.instances.slider.slideTo(idx);
      });

      this.settings.instances.slider.on('slideChange', () => {
        this.settings.instances.thumbs.slideTo(this.settings.instances.slider.activeIndex);
      });
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(this.querySelectorAll(this.selectors.mediaItem)).find(
        (media) => Number(media.dataset.mediaId) === id
      );
      if (!mediaFound) return;
      this.settings.instances.slider.slideTo(Number(mediaFound.dataset.index));
    }
  }

  customElements.define('product-media', ProductMedia);
}
